import { Module } from 'vuex'
import { RootState } from '@/store'
import mutations from '@/store/doctor/mutations'
import { path } from '@/store/doctor/types'
import { mutation } from '@/utils/mutation'
import state, { IDoctorState } from '@/store/doctor/state'

export * from '@/store/doctor/state'

export const store: Module<IDoctorState, RootState> = {
  state,
  mutations: mutation(mutations, path)
}
